import { amplifyProxy } from '@/services/directApi'

export default {
  namespaced: true,
  state: {
    tenants: '',
    loading: false,
    error: null
  },
  mutations: {
    SET_TENANTS(state, data) {
      state.tenants = data
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async getTenantsCount({ commit, dispatch }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      try {
        const [active, arrears, notChased, historic] = await Promise.all([
          dispatch('getTenantsActive'),
          dispatch('getTenantsArrears'),
          dispatch('getTenantsNotChased'),
          dispatch('getTenantsHistoric')
        ])

        const tenantData = {
          active: active.data,
          inArrears: arrears.data,
          notChased: notChased.data,
          historic: historic.data
        }

        commit('SET_TENANTS', tenantData)
        return tenantData
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async getTenantsActive({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/tenants/active/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getTenantsHistoric({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/tenants/historic/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getTenantsArrears({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/tenants/arrears/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getTenantsNotChased({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/tenants/notChased/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    }
  }
}